import { DefaultTheme } from 'styled-components';

const defaultTheme: DefaultTheme = {
  fonts: {
    serif: "'Sharon Serif'",
    normal: "'Sharon Sans'",
    bold: "'Sharon Sans'",
  },
  colors: {
    display: {
      0: '#FFFFFF',
      50: '#F7FAFD',
      100: '#EFF4F8',
      200: '#E6ECF2',
      300: '#D5DEE8',
      400: '#BCC8D6',
      500: '#919DAB',
      600: '#67707D',
      700: '#424A53',
      800: '#31383F',
      900: '#20252A',
    },
    stone: {
      50: '#E8FEF3',
      100: '#CEFDE5',
      200: '#86FDC1',
      300: '#42EC9A',
      400: '#0FCC7D',
      500: '#00A868',
      600: '#008E5A',
      700: '#00734D',
      800: '#005C41',
      900: '#004033',
    },
    ton: {
      50: '#ECFEE8',
      100: '#D2FDC9',
      200: '#9AFD86',
      300: '#5FFA40',
      400: '#39E61C',
      500: '#00AD00',
      600: '#008C00',
      700: '#006E00',
      800: '#005100',
      900: '#003B00',
    },
    danger: {
      100: '#FDE5E2',
      200: '#FBBDB6',
      300: '#F77B6E',
      400: '#DD4F40',
      500: '#C6322A',
      600: '#830700',
    },
    warning: {
      100: '#FFF7E0',
      200: '#FFE8A3',
      300: '#FFCE5B',
      400: '#F2B417',
      500: '#CF810C',
      600: '#BA6708',
    },
  },
  radii: [0, 4, 8, 12],
  breakpoints: {
    xxs: 0,
    xs: 360,
    sm: 576,
    md: 768,
    lg: 1024,
    xl: 1200,
  },
  shadows: {
    sm: '0px 0px 4px rgba(0, 0, 0, 0.15)',
    md: '0px 0px 8px rgba(0, 0, 0, 0.15)',
    lg: '0px 0px 20px rgba(0, 0, 0, 0.15)',
    xl: '0px 0px 32px rgba(0, 0, 0, 0.15)',
  },
};

export default defaultTheme;
